import { render, staticRenderFns } from "./on-call-button.vue?vue&type=template&id=8e1f0ea6&scoped=true"
import script from "./on-call-button.vue?vue&type=script&lang=js"
export * from "./on-call-button.vue?vue&type=script&lang=js"
import style0 from "./on-call-button.vue?vue&type=style&index=0&id=8e1f0ea6&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1f0ea6",
  null
  
)

export default component.exports